import { calculateGoogleMapsZoomLevel } from "./helpers";
import { BERLIN_CENTER, DEFAULT_RADIUS_M, DEFAULT_ZOOM_LEVEL, LONDON_CENTER, MAX_ZOOM_LEVEL, UK_MARKETPLACE_ID } from "./const";

export type CreateMapOptions = {
  mapsLibrary: google.maps.MapsLibrary;
  mapId: string;
  mapEl?: HTMLElement;
  isMobile?: boolean;
  marketplaceId?: string;
};

export function createMap(options: CreateMapOptions): google.maps.Map {
  const { mapsLibrary, mapEl, mapId, isMobile, marketplaceId } = options;

  if (!mapEl) throw Error("Map element not found");

  const center = marketplaceId === UK_MARKETPLACE_ID ? LONDON_CENTER : BERLIN_CENTER;
  const radiusInMeters = DEFAULT_RADIUS_M;

  return new mapsLibrary.Map(mapEl, {
    center,
    zoom: calculateGoogleMapsZoomLevel(mapEl, center, radiusInMeters) || DEFAULT_ZOOM_LEVEL,
    streetViewControl: false,
    mapTypeControl: false,
    fullscreenControl: false,
    zoomControl: false,
    disableDefaultUI: !isMobile,
    maxZoom: MAX_ZOOM_LEVEL,
    mapId,
    gestureHandling: "greedy",
    isFractionalZoomEnabled: true,
    clickableIcons: false,
  });
}
